import React from 'react'
import * as R from 'remeda'

import { compact, getByPath } from '~/utils'

import { useSurveyQueryCustomerAttributeGroups } from './useSurveyQueryCustomerAttributeGroups'

export const useSurveyQueryReferencedCustomerAttributeIds = () => {
  const customerAttributeGroups = useSurveyQueryCustomerAttributeGroups()

  return React.useMemo(
    () =>
      R.pipe(
        customerAttributeGroups,
        R.flatMap(R.prop('customerAttributes')),
        R.flatMap(R.prop('filterGroups')),
        R.flatMap(R.identity()),
        R.flatMap(getByPath('customerAttribute.customerAttributeIds')),
        compact,
      ),
    [customerAttributeGroups],
  )
}
